import React, { useContext, useEffect, useState } from 'react'
import "../AdminDashboard.css"
import "./AddBook.css"
import axios from "axios"
import { AuthContext } from '../../../../Context/AuthContext'
import { Card, Button, Input, Select } from '../../../../ui'
import BookIcon from '@material-ui/icons/Book';
import CircularProgress from '@material-ui/core/CircularProgress';

function AddBook() {
    const API_URL = process.env.REACT_APP_API_URL
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useContext(AuthContext)

    const [bookName, setBookName] = useState("")
    const [alternateTitle, setAlternateTitle] = useState("")
    const [author, setAuthor] = useState("")
    const [bookCountAvailable, setBookCountAvailable] = useState(null)
    const [language, setLanguage] = useState("")
    const [publisher, setPublisher] = useState("")
    const [allCategories, setAllCategories] = useState([])
    const [selectedCategories, setSelectedCategories] = useState([])
    const [recentAddedBooks, setRecentAddedBooks] = useState([])

    /* Fetch all the Categories - load on focus */
    const loadCategories = async () => {
        if (allCategories.length > 0) return; // Already loaded
        try {
            const response = await axios.get(API_URL + "api/categories/allcategories")
            if (response.data && response.data.length > 0) {
                const all_categories = response.data.map(category => (
                    { value: `${category._id}`, text: `${category.categoryName}` }
                ))
                setAllCategories(all_categories)
            }
        }
        catch (err) {
            console.log("Error loading categories:", err)
        }
    }

    /* Adding book function */
    const addBook = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        const BookData = {
            bookName: bookName,
            alternateTitle: alternateTitle,
            author: author,
            bookCountAvailable: bookCountAvailable,
            language: language,
            publisher: publisher,
            categories: selectedCategories,
            isAdmin: user.isAdmin
        }
        try {
            const response = await axios.post(API_URL + "api/books/addbook", BookData)
            if (recentAddedBooks.length >= 5) {
                recentAddedBooks.splice(-1)
            }
            setRecentAddedBooks([response.data, ...recentAddedBooks])
            setBookName("")
            setAlternateTitle("")
            setAuthor("")
            setBookCountAvailable(null)
            setLanguage("")
            setPublisher("")
            setSelectedCategories([])
            alert("Book Added Successfully 🎉")
        }
        catch (err) {
            console.log(err)
            alert("Failed to add book. Please try again.")
        }
        setIsLoading(false)
    }

    useEffect(() => {
        const getallBooks = async () => {
            try {
                const response = await axios.get(API_URL + "api/books/allbooks")
                setRecentAddedBooks(response.data.slice(0, 5))
            } catch (err) {
                console.log(err)
            }
        }
        getallBooks()
    }, [API_URL])

    return (
        <div className="addbook-container">
            <h2 className="addbook-title">Add a Book</h2>

            <Card padding="lg" className="addbook-form-card">
                <form className='addbook-form' onSubmit={addBook}>
                    <div className="addbook-form-grid">
                        <Input
                            label="Book Name"
                            type="text"
                            name="bookName"
                            value={bookName}
                            onChange={(e) => { setBookName(e.target.value) }}
                            required
                            placeholder="Enter book name"
                        />

                        <Input
                            label="Alternate Title"
                            type="text"
                            name="alternateTitle"
                            value={alternateTitle}
                            onChange={(e) => { setAlternateTitle(e.target.value) }}
                            placeholder="Enter alternate title"
                        />

                        <Input
                            label="Author Name"
                            type="text"
                            name="author"
                            value={author}
                            onChange={(e) => { setAuthor(e.target.value) }}
                            required
                            placeholder="Enter author name"
                        />

                        <Input
                            label="Language"
                            type="text"
                            name="language"
                            value={language}
                            onChange={(e) => { setLanguage(e.target.value) }}
                            placeholder="Enter language"
                        />

                        <Input
                            label="Publisher"
                            type="text"
                            name="publisher"
                            value={publisher}
                            onChange={(e) => { setPublisher(e.target.value) }}
                            placeholder="Enter publisher"
                        />

                        <Input
                            label="No. of Copies Available"
                            type="number"
                            name="copies"
                            value={bookCountAvailable || ''}
                            onChange={(e) => { setBookCountAvailable(e.target.value) }}
                            required
                            placeholder="Enter number of copies"
                        />
                    </div>

                    <Select
                        id="categories-select"
                        label={
                            <>
                                Categories<span className="required-field">*</span>
                            </>
                        }
                        placeholder="Select categories"
                        multiple
                        searchable
                        value={selectedCategories || []}
                        options={allCategories}
                        onChange={(e) => setSelectedCategories(Array.isArray(e.target.value) ? e.target.value : [])}
                        onFocus={loadCategories}
                        onOpen={loadCategories}
                    />

                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        disabled={isLoading}
                        leadingIcon={isLoading ? <CircularProgress size={20} /> : <BookIcon />}
                        className="addbook-submit"
                    >
                        {isLoading ? 'Adding...' : 'Add Book'}
                    </Button>
                </form>
            </Card>

            <div className="addbook-recent">
                <h3 className="addbook-section-title">Recently Added Books</h3>
                {recentAddedBooks.length > 0 ? (
                    <Card padding="md" className="addbook-table-card">
                        <div className="addbook-table-wrapper">
                            <table className='addbook-table'>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Book Name</th>
                                        <th>Added Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recentAddedBooks.map((book, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{book.bookName}</td>
                                            <td>{book.createdAt ? book.createdAt.substring(0, 10) : 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                ) : (
                    <Card padding="lg" className="addbook-empty-state">
                        <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>No books added yet.</p>
                    </Card>
                )}
            </div>
        </div>
    )
}

export default AddBook
